import request from "@/utils/request";

export function getTemplateFileUrl() {
  return request({
    url: "/test/reportManageAccident/getTemplateFileUrl",
    method: "get",
  });
}
export function selectPageList(data) {
  return request({
    url: "/test/reportManageAccident/selectPageList",
    method: "post",
    data: data,
  });
}
export function insertOne(data) {
  return request({
    url: "/test/reportManageAccident/insertOne",
    method: "post",
    data: data,
  });
}

export function detailData(data) {
  return request({
    url: "/test/reportManageAccident/detail",
    method: "post",
    data: data,
  });
}



